import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Restangular } from 'ngx-restangular';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AnalyticsService {
    constructor(private httpClient: HttpClient, @Inject(Restangular) public Restangular: any) {
    }


    getAnalytics(options: string) {
        debugger;
        return this.Restangular.one('analytics' + options).customGET('');
    }

    getEkubAnalytics(id: string, options: string) {
        debugger;
        return this.Restangular.one('analytics/' + id + options).customGET('');
    }

    getEkub(id: string, options: string = '') {
        debugger;
        return this.Restangular.one('ekubs/' + id + options).customGET('');
    }

}
